export default "__VITE_ASSET__CM4nyz$w__"